import { useCallback } from 'react';
import { useSearchParams } from '@direct-frontend/modules-router';
import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { constructorProductLoggingEvents } from '../lib/constructorProductLoggingEvents';
import { CONSTRUCTOR_PAGE_RIGHT_BAR_KEY } from '../model/constants';
import { changeConstructorRightBarSection } from '../model/slices';

export const useChangeConstructorRightBarSection = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onChange = useCallback(
        (sectionInstanceId?: string, moduleId?: string) => {
            const isOpen = Boolean(sectionInstanceId);
            let target: 'none' | 'page' | 'section' = 'none';

            if (sectionInstanceId === CONSTRUCTOR_PAGE_RIGHT_BAR_KEY) {
                target = 'page';
            } else if (isOpen) {
                target = 'section';
            }

            logEventString(constructorProductLoggingEvents.RightBar.Toggle, isOpen ? 'open' : 'close', {
                target,
                hasModule: Boolean(moduleId),
            });

            if (!sectionInstanceId) {
                searchParams.delete('section');
                searchParams.delete('module');
            } else if (sectionInstanceId && !moduleId) {
                searchParams.set('section', sectionInstanceId);
                searchParams.delete('module');
            } else if (sectionInstanceId && moduleId) {
                searchParams.set('section', sectionInstanceId);
                searchParams.set('module', moduleId);
            }

            changeConstructorRightBarSection(sectionInstanceId, moduleId);

            if (sectionInstanceId && sectionInstanceId !== CONSTRUCTOR_PAGE_RIGHT_BAR_KEY) {
                searchParams.set('tab', 'sections');
            }

            setSearchParams(searchParams, { replace: true });
        },
        [searchParams, setSearchParams]
    );

    return onChange;
};
